
<template>
	<v-list-item-icon class="mr-4">
		<v-img contain height="20px" width="20px"  v-bind:src="img" />
	</v-list-item-icon>
</template>

<style lang="less">
</style>

<script type="text/javascript">
	// import Vuex from "vuex";
	// import - from "@/components/"
	export default {
		name: "AssessmentNavigationItemIcon", 
		props: {
			part: {type: Number}, 
			section: {type: Number}	
		},
		data: () => {
			return {

			}
		},
		// components: {

		// },
		computed: {
			iconPath(){
				var str = "@/assets/images/cn-icon-part-"
				str += this.part;
				if( typeof this.section !== "undefined" ){
					str += "-"
					str += "1"
				}
				str += ".png";
				return this.replaceSpaces(str)
			},
			img(){
				if( typeof this.section == "undefined" ){
					return require(`@/assets/images/cn-icon-part-${this.part + 1}.png`)
				}
				return require(`@/assets/images/cn-icon-part-${this.part + 1}-${this.section + 1}.png`)
			}
			// ...Vuex.mapState({})
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>